import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'cmp-terms',
  template: `<div class="container">
  <div class="container-terms">
    <ng-content select="[priv-terms]"></ng-content>
  </div>
</div>
`,
  styles: [`.container-terms{margin-top:100px;margin-bottom:150px}`]
})
export class TermsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
